import React, { type FC } from 'react'
import {
  DataListHeader,
  Panel,
  PaginationBar,
  NoResults,
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { COL_SPAN } from '../helpers/constants'
import { useAtom } from 'jotai'
import { filtersPagedListAtom, filtersQueryAtom } from '../state/state'
import { FilterRow } from './FilterRow'
import { useAtomCallback } from 'jotai/utils'
import {
  changeFiltersFieldOrdering,
  changeFiltersPage,
  changeFiltersPageSize,
} from '../callbacks/filters'

export const FiltersList: FC = () => {
  const intl = useIntl()

  const [filtersPage] = useAtom(filtersPagedListAtom)
  const [query] = useAtom(filtersQueryAtom)
  const filtersList = filtersPage.Items
  const handleChangePage = useAtomCallback(changeFiltersPage)
  const handleChangePageSize = useAtomCallback(changeFiltersPageSize)
  const handleChangeColumnsOrder = useAtomCallback(changeFiltersFieldOrdering)

  const heads = [
    {
      field: 'Id',
      label: intl.formatMessage({ id: 'Load.MailupCommon.Id' }),
      span: COL_SPAN.ID,
      sortable: true,
    },
    {
      field: 'Name',
      label: intl.formatMessage({ id: 'Load.MailupCommon.Name' }),
      span: COL_SPAN.NAME,
      sortable: true,
    },
    {
      field: 'Type',
      label: intl.formatMessage({ id: 'Load.MailupCommon.Type' }),
      span: COL_SPAN.TYPE,
      sortable: false,
    },
    {
      field: 'Category',
      label: intl.formatMessage({ id: 'Load.Common.Category' }),
      span: COL_SPAN.CATEGORY,
      sortable: false,
    },
    {
      field: 'UpdateDate',
      label: intl.formatMessage({ id: 'Load.MailupCommon.LastUpdated' }),
      span: COL_SPAN.LAST_UPDATE,
      sortable: true,
    },
    {
      field: 'Actions',
      label: intl.formatMessage({ id: 'Load.MailupCommon.Actions' }),
      span: COL_SPAN.ACTIONS,
      sortable: false,
    },
  ]

  return filtersPage.TotalItems === 0 ? (
    <Panel>
      <NoResults
        text={intl.formatMessage({
          id: 'Load.Common.NoResultChosen',
        })}
      />
    </Panel>
  ) : (
    <Panel>
      <DataListHeader
        heads={heads}
        orderByStatus={query.orderBy}
        orderDescendingStatus={query.orderDescending}
        handleChangeColumnsOrderCallback={handleChangeColumnsOrder}
      />
      <div>
        {filtersList.map((filter) => (
          <FilterRow key={filter.Id} filter={filter} />
        ))}
      </div>
      <PaginationBar
        pageNumber={filtersPage.PageNumber}
        pageSize={filtersPage.PageSize}
        totalItems={filtersPage.TotalItems}
        handleChangePage={handleChangePage}
        handleChangePageSize={handleChangePageSize}
      />
    </Panel>
  )
}
